import Vue from "vue"
import Vuex from "vuex"
import VueCookies from "vue-cookies"

Vue.use(Vuex)
Vue.use(VueCookies)

const apiURL = "https://medex.lifeforcept.com:3000"

export default new Vuex.Store({
	state: {
		token: Vue.$cookies.get("token") || "",
		user: {
			userID: parseInt(Vue.$cookies.get("userID")) || "",
			admin: parseInt(Vue.$cookies.get("admin")) || "",
		},
		dateSelectionMode: false,
		dateSelection: [],
		managePatient: {
			userID: 0,
			firstName: "",
			lastName: "",
		},
	},
	mutations: {
		auth_success(state, loginData) {
			state.token = loginData.token
			state.user = loginData.user
		},
		logout(state) {
			state.token = ""
			state.user = {}
		},
		enterDateSelectionMode(state) {
			state.dateSelection = []
			state.dateSelectionMode = true
		},
		exitDateSelectionMode(state) {
			state.dateSelectionMode = false
		},
		appendDateSelection(state, date) {
			state.dateSelection.push(date)
		},
		removeDateSelection(state, date) {
			const index = state.dateSelection.indexOf(date)
			if (index > -1) {
				state.dateSelection.splice(index, 1)
			}
		},
		selectPatient(state, patient) {
			state.managePatient = patient
		},
		clearDateSelection(state) {
			state.dateSelection = []
		},
	},
	actions: {
		login({ commit }, creds) {
			return new Promise((resolve, reject) => {
				fetch(apiURL + "/login", {
					method: "POST",
					body: JSON.stringify({
						email: creds.email,
						password: creds.password,
					}),
					headers: new Headers({
						"Content-Type": "application/json",
					}),
				}).then(res => {
					if (res.ok) {
						res.json().then(json => {
							Vue.$cookies.set("token", json.token)
							Vue.$cookies.set("userID", json.user.userID)
							Vue.$cookies.set("admin", json.user.admin)
							commit("auth_success", json)
							resolve(res)
						})
					} else {
						reject(res)
					}
				})
			})
		},
		logout({ commit }) {
			return new Promise(resolve => {
				Vue.$cookies.remove("token")
				Vue.$cookies.remove("userID")
				Vue.$cookies.remove("admin")
				commit("logout")
				resolve()
			})
		},
		enterDateSelectionMode({ commit }) {
			return new Promise(resolve => {
				commit("enterDateSelectionMode")
				resolve()
			})
		},
		exitDateSelectionMode({ commit }) {
			return new Promise(resolve => {
				commit("exitDateSelectionMode")
				resolve()
			})
		},
		appendDateSelection({ commit }, date) {
			return new Promise(resolve => {
				commit("appendDateSelection", date)
				resolve()
			})
		},
		removeDateSelection({ commit }, date) {
			return new Promise(resolve => {
				commit("removeDateSelection", date)
				resolve()
			})
		},
		selectPatient({ commit }, userID) {
			return new Promise(resolve => {
				commit("selectPatient", userID)
				resolve()
			})
		},
		clearDateSelection({ commit }) {
			return new Promise(resolve => {
				commit("clearDateSelection")
				resolve()
			})
		},
	},
	getters: {
		isLoggedIn: state => !!state.token,
		isAdmin: state => !!state.user.admin,
		userID: state => state.userID,
		dateSelection: state => state.dateSelection,
	},
})
